import React, { useState } from "react";
import PropTypes from 'prop-types';
import { NeuroMessage, ShareViaEmailModal, ShareViaSmsModal } from '@ignitesales/neuro-application';

import ClientLogo from "./ClientLogo.jsx";
import useHideOnScroll from "../hooks/useHideOnScroll.mjs";

const StickyHeader = ({
  pageName,
  customIcons,
  useEmail = true,
  useTextMessage = true,
  setShowContactForm,
}) => {
    const componentClass = 'stickyHeader';
    const isVisible = useHideOnScroll(500, pageName);
    const [showEmail, setShowEmail] = useState(false);
    const [showTextMsg, setShowTextMsg] = useState(false);

    return (
      isVisible && <div className={componentClass}>
          <div className={`${componentClass}__logoContainer`}>
            <ClientLogo className="clientLogo" />
          </div>
          <div className={`${componentClass}__textContainer`}>
              <NeuroMessage id="summary.title" tagName="h1"/>
              <NeuroMessage id="summary.subtext" tagName="p" />
          </div>
          <button className={`${componentClass}__textContainer btn complete-btn`} onClick={() => setShowContactForm(true)}>
              <i className="ion-md-checkmark-circle-outline" />
              <NeuroMessage id='summary.completeBtn' />
          </button>

          <div className={`${componentClass}__iconButtonContainer`}>
            <button className="iconButton" onClick={() => setShowContactForm(true)}>
              <i className="ion-md-checkmark-circle-outline" />
            </button>

            { useTextMessage &&  <button className="iconButton" onClick={() => setShowTextMsg(true)}>
              { customIcons?.textMessageIcon ? (customIcons.textMessageIcon) : <i className="fa fa-comments-o" /> }
            </button> }

            { useEmail && <button className="iconButton" onClick={() => setShowEmail(true)}>
              { customIcons?.emailIcon ? (customIcons.emailIcon) : <i className="fa fa-envelope-o" /> }
            </button> }
          </div>

          { useTextMessage && <ShareViaSmsModal isOpen={showTextMsg} onClose={() => setShowTextMsg(false)} /> }
          { useEmail && <ShareViaEmailModal isOpen={showEmail} onClose={() => setShowEmail(false)} /> }
      </div>
    );
};

StickyHeader.propTypes = {
  pageName: PropTypes.string,
  useEmail: PropTypes.bool,
  useTextMessage: PropTypes.bool,
  customIcons: PropTypes.object,
  setShowContactForm: PropTypes.func.isRequired
};

StickyHeader.defaultProps= {
  useEmail: true,
  useTextMessage: true
};

export default StickyHeader;
